module.exports = __webpack_public_path__ + "static/media/map.ccb8c6ec.svg";